/*
*
* File JS componente HEADER
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

import Headroom from "headroom.js";


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const html = document.querySelector('html');
const body = document.querySelector('body');
const context = document.querySelector('#header');
const burgerButton = context.querySelector('.header__burger');

const linksWithSubMenu = context.querySelectorAll('li.menu-item-has-children');
const subMenu = context.querySelectorAll('li.menu-item-has-children > ul.sub-menu');

const buttonCloseSearch = context.querySelector('#header_search_close');
const buttonToggleSearch = context.querySelector('.menu-item--search button');

const headroomOptions =
{
    offset : 75
}


/**
*	Funzione di gestione apertura/chiusura menu mobile
*
*	@return {void}
*/
const header = () =>
{
    const headerExpanded = window.__GLOBAL.resolutions.headerExpanded|1025;
    let isExpanded = window.innerWidth >= headerExpanded ? true : false;

    // Inizializziamo Headroom
    const headroom  = new Headroom(context, headroomOptions);
    headroom.init();
    
    // Apriamo o chiudiamo il Menu
    burgerButton.addEventListener('click', () =>
    {
        //context.classList.add('transition-on');
        context.classList.toggle('menu-is-open');
    });
    
    // Apriamo o chiudiamo il Cerca
    // buttonToggleSearch.addEventListener('click', () =>
    // {
    //     //context.classList.add('transition-on');
    //     context.classList.toggle('search-is-open');
    // });
    
    // Chiudiamo il Cerca
    // buttonCloseSearch.addEventListener('click', () =>
    // {
    //     //context.classList.add('transition-on');
    //     context.classList.remove('search-is-open');
    // });

    // Chiudiamo il menu con il tasto ESC
    document.addEventListener('keyup', (evt) =>
    {
        if(evt.code === 'Escape')
        {
            if( context.classList.contains('menu-is-open') )
                context.classList.remove('menu-is-open');

            if( context.classList.contains('search-is-open') )
                context.classList.remove('search-is-open');
        }
    });

    // Apriamo e Chiudiamo i SubMenu
    linksWithSubMenu.forEach((link, index) =>
    {
        link.addEventListener('click', evt=>
        {
            if( isExpanded )
                return;

            if( !evt.target.parentElement.classList.contains('menu-item-with-arrow'))
                return;
            
            evt.preventDefault()
            $(subMenu[index]).slideToggle(300);
        });

        // Aggiungiamo classe all'header quando hover su menu-item-has-children
        link.addEventListener('mouseenter', () =>
        {
            context.classList.add('submenu-hover');
        });

        link.addEventListener('mouseleave', () =>
        {
            context.classList.remove('submenu-hover');
        });
    });


    /*/ Funzioni menu
    --------------------------------------------------------------------------*/
    function flushHeader()
    {
        context.classList.remove
        (
            'menu-is-open',
            'search-is-open'
        );

        $(subMenu).slideUp(0).removeAttr('style');
    }


    /* On Screen Media Query
    --------------------------------------------------------------------------*/
    function resize(mediaQuery)
    {
        flushHeader();
        context.classList.remove('transition-on');

        setTimeout(() =>
        {
            context.classList.add('transition-on');
        }, 100);

        isExpanded = mediaQuery.matches;
    }

    const  mediaQuery = window.matchMedia(`(min-width: ${headerExpanded}px)`);
    resize(mediaQuery);
    mediaQuery.addListener(resize);
    

    /* Attiviamo le transizioni in ritardo
    --------------------------------------------------------------------------*/
    setTimeout(() =>
    {
        context.classList.add('transition-on');
    }, 100);
}

export default header;

//--------------------------------------------------------------------//